import { Component, OnInit } from "@angular/core";
import { ApiService } from "src/app/core/services";
import { GeneralService } from "src/app/commons/services";

interface ContactForm {
  name: string;
  email: string;
  phone: string;
  message: string;
  subject: string;
}

@Component({
  selector: "sv-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.scss"],
})
export class ContactComponent implements OnInit {
  contactForm: ContactForm = {
    name: "",
    email: "",
    phone: "",
    message: "",
    subject: "",
  };

  emailSent: boolean = false;
  emailSending: boolean = false;

  errors = {
    customerPhoneError: false,
  };

  constructor(private api: ApiService, public generalService: GeneralService) {}

  ngOnInit(): void {}

  async sendMail() {
    try {
      this.emailSending = true;
      const { status_code, result } = await this.api
        .post(this.contactForm, "/contact")
        .toPromise();

      if (status_code === 200 && result) {
        this.emailSending = false;
        this.emailSent = true;
        return result;
      }
      return {};
    } catch (error) {
      this.emailSending = false;
      console.error("Contact Email Error : ", error);
      throw error;
    }
  }

  phoneChange(event) {
    let phone = event.target.value;

    if (phone.length < 7) {
      this.errors.customerPhoneError = true;
    } else {
      this.errors.customerPhoneError = false;
    }
  }
}
